/** Identité établissement pour ticket / duplicata — champs réels uniquement. */

function formatSiretDisplay(digits) {
  const d = String(digits || '').replace(/\D/g, '');
  if (d.length !== 14) return null;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 9)} ${d.slice(9, 14)}`;
}

/**
 * @param {object|null|undefined} commercant — réponse GET /commercants/:id
 * @returns {{ lines: string[], hasMinimumIdentity: boolean }}
 */
export function buildCommercantTicketIdentity(commercant) {
  if (!commercant || typeof commercant !== 'object') {
    return { lines: [], hasMinimumIdentity: false };
  }
  const lines = [];
  const nom = String(commercant.nom || '').trim();
  if (nom) lines.push(nom);

  const street = [commercant.rue, commercant.adresse2].filter((s) => String(s || '').trim()).join(', ');
  const cityLine = [commercant.codePostal, commercant.ville].filter((s) => String(s || '').trim()).join(' ');
  const addr = [street, cityLine].filter(Boolean).join(' — ');
  if (addr) lines.push(addr);

  const siretLabel = formatSiretDisplay(commercant.siret);
  if (siretLabel) lines.push(`SIRET ${siretLabel}`);

  return {
    lines,
    hasMinimumIdentity: Boolean(nom),
  };
}
